import React from 'react';

import { IconWrapper } from '@/components/ui/IconWrapper';
import {
  Anchor,
  BarChart3,
  Building2,
  Calculator,
  CircleHelp,
  Clock,
  DollarSign,
  Droplets,
  FileText,
  Flame,
  Fuel,
  Globe,
  Home,
  Landmark,
  Leaf,
  Map,
  MapPin,
  MoreHorizontal,
  Pencil,
  Receipt,
  Search,
  Settings,
  ShieldCheck,
  Ship,
  ShoppingCart,
  Star,
  TrendingUp,
  Users,
  Wrench,
  Zap
} from 'lucide-react';

type IconMapType = Record<string, React.ComponentType>;

/** Generic icon name → lucide-react component. */
const iconMap: IconMapType = {
  anchor: Anchor,
  'bar-chart': BarChart3,
  'building-2': Building2,
  calculator: Calculator,
  clock: Clock,
  'dollar-sign': DollarSign,
  droplets: Droplets,
  'file-text': FileText,
  flame: Flame,
  fuel: Fuel,
  globe: Globe,
  home: Home,
  landmark: Landmark,
  leaf: Leaf,
  map: Map,
  'map-pin': MapPin,
  'more-horizontal': MoreHorizontal,
  pencil: Pencil,
  receipt: Receipt,
  search: Search,
  settings: Settings,
  'shield-check': ShieldCheck,
  ship: Ship,
  'shopping-cart': ShoppingCart,
  star: Star,
  'trending-up': TrendingUp,
  users: Users,
  wrench: Wrench,
  zap: Zap
};

export const getIcon = (iconName?: string): React.ReactNode => {
  if (!iconName) return <IconWrapper icon={CircleHelp} />;
  const IconComponent = iconMap[iconName.toLowerCase()] ?? CircleHelp;
  return <IconWrapper icon={IconComponent} />;
};
